import preval from 'preval.macro'
import format from 'date-fns/format'

const buildTimestamp = preval`module.exports = new Date().getTime();`
const buildNumber = process.env.REACT_APP_BUILD_NUMBER || `${format(buildTimestamp, 'yyyyMMdd-HHmmss')}`

export default buildNumber
